import { createElement, Fragment } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { close, Icon } from '@wordpress/icons';
import { Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import OverlayMenuIcon from './overlay-menu-icon';
export default function ResponsiveWrapper(_ref) {
  let {
    children,
    id,
    isOpen,
    isResponsive,
    onToggle,
    isHiddenByDefault,
    classNames,
    styles,
    hasIcon
  } = _ref;

  if (!isResponsive) {
    return children;
  }

  const responsiveContainerClasses = classnames('wp-block-navigation__responsive-container', classNames, {
    'is-menu-open': isOpen,
    'hidden-by-default': isHiddenByDefault
  });
  const openButtonClasses = classnames('wp-block-navigation__responsive-container-open', {
    'always-shown': isHiddenByDefault
  });
  const modalId = `${id}-modal`;
  const dialogProps = {
    className: 'wp-block-navigation__responsive-dialog',
    ...(isOpen && {
      role: 'dialog',
      'aria-modal': true,
      'aria-label': __('Menu')
    })
  };
  return createElement(Fragment, null, !isOpen && createElement(Button, {
    "aria-haspopup": "true",
    "aria-label": __('Open menu'),
    className: openButtonClasses,
    onClick: () => onToggle(true)
  }, hasIcon && createElement(OverlayMenuIcon, null), !hasIcon && createElement("span", {
    className: "wp-block-navigation__toggle_button_label"
  }, __('Menu'))), createElement("div", {
    className: responsiveContainerClasses,
    style: styles,
    id: modalId
  }, createElement("div", {
    className: "wp-block-navigation__responsive-close",
    tabIndex: "-1"
  }, createElement("div", dialogProps, createElement(Button, {
    className: "wp-block-navigation__responsive-container-close",
    "aria-label": __('Close menu'),
    onClick: () => onToggle(false)
  }, createElement(Icon, {
    icon: close
  })), createElement("div", {
    className: "wp-block-navigation__responsive-container-content",
    id: `${modalId}-content`
  }, children)))));
}
//# sourceMappingURL=responsive-wrapper.js.map